module.exports = __webpack_public_path__ + "img/12.07cfba8b.jpg";